import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class GrnIdRequest {
    @ApiProperty()
    @IsNotEmpty()
    grnId: number;
}